// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/common/jquery-3.6.0.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("/common/jquery.query.js", import.meta.url);
var ___HTML_LOADER_IMPORT_2___ = new URL("/common/jquery.json.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_3___ = new URL("/common/default.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_4___ = new URL("/common/timer.js", import.meta.url);
var ___HTML_LOADER_IMPORT_5___ = new URL("/2-choices/component-cp/index.js", import.meta.url);
var ___HTML_LOADER_IMPORT_6___ = new URL("/2-choices/component-cp/index.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_7___ = new URL("/2-choices/component-cp/attention.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_8___ = new URL("/2-choices/component-cp/start-button.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_9___ = new URL("/2-choices/component-cp/footer-ponta.scss", import.meta.url);
// Module
var code = `<!DOCTYPE html>
<html lang="ja">
  <head
    prefix="og: https://ogp.me/ns# fb: https://ogp.me/ns/ fb# article: https://ogp.me/ns/article#"
  >
    
    <!---->
    <!--デフォルト値の設定-->




<meta charset="UTF-8" />
<meta
  name="viewport"
  content="width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1"
/>
<meta name="format-detection" content="telephone=no" />
<title>どんな日もミカタに！Pontaの星座＆タロット占い！｜【Ponta】お金のミカタ</title>
<meta name="description" content="お金のミカタは、ためる(ポン活)・ふやす(運用)・そなえる(保険)・まなべるサービスを紹介する、“Ponta[ポンタ]“の公式金融総合サイトです" />
<link rel="index" href="index.htm" />
<!-- icon -->
<link
  rel="shortcut icon"
  type="image/vnd.microsoft.icon"
  href="/cmn/img/favicon.ico"
/>
<link rel="icon" type="image/x-icon" href="/cmn/img/favicon.ico" />
<link
  rel="apple-touch-icon"
  sizes="180x180"
  href="/cmn/img/apple-touch-icon.png"
/>
<!-- og -->
<meta property="og:url" content="https://www.finance.ponta.jp/2-choices/0007/" />
<meta property="og:type" content="website" />
<meta property="og:title" content="どんな日もミカタに！Pontaの星座＆タロット占い！｜【Ponta】お金のミカタ" />
<meta property="og:description" content="お金のミカタは、ためる(ポン活)・ふやす(運用)・そなえる(保険)・まなべるサービスを紹介する、“Ponta[ポンタ]“の公式金融総合サイトです" />
<meta property="og:site_name" content="【Ponta】お金のミカタ" />
<meta property="og:image" content="https://www.finance.ponta.jp/cdn/img/ogp.png" />
<!-- Twitter -->
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:site" content="@Ponta" />

${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_0___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_1___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_2___}">${"<" + "/script"}>

<!-- StyleSheet -->
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_3___}" />

<!-- noto sans jp の読み込み -->
<link rel="preconnect" href="https://fonts.gstatic.com" />
<link
  rel="preload"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  as="style"
/>
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  media="print"
  onload="this.media = 'all'"
/>

<!-- corporate-logo の読み込み -->
<link rel="preload" href="/font/corporate-logo.css" as="style" />
<link
  rel="stylesheet"
  href="/font/corporate-logo.css"
  media="print"
  onload="this.media = 'all'"
/>

<!-- Google Tag Manager (loadイベント後に遅延読み込み) -->
<!-- 旧コード: Clarityとアニメーションの競合解消後に戻す
${"<" + "script"}>
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-P3QVP6P");
${"<" + "/script"}>
-->
${"<" + "script"}>
  window.dataLayer = window.dataLayer || [];
  window.addEventListener("load", function () {
    dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = document.getElementsByTagName("script")[0],
      j = document.createElement("script");
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=GTM-P3QVP6P";
    f.parentNode.insertBefore(j, f);
  });
${"<" + "/script"}>

<!-- Google広告 -->
${"<" + "script"}
  async
  src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2528660706528280"
  crossorigin="anonymous"
>${"<" + "/script"}>

    <meta name="robots" content="noindex" />
    ${"<" + "script"} src="${___HTML_LOADER_IMPORT_4___}">${"<" + "/script"}>
    ${"<" + "script"} src="${___HTML_LOADER_IMPORT_5___}">${"<" + "/script"}>
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_6___}" />
  </head>

  <body>
    <!-- Google Tag Manager (noscript) -->
<noscript
  ><iframe
    src="https://www.googletagmanager.com/ns.html?id=GTM-P3QVP6P"
    height="0"
    width="0"
    style="display: none; visibility: hidden"
  ></iframe
></noscript>
<!-- End Google Tag Manager (noscript) -->

    <div class="body-contents">
      <br />
      <main>
        <div class="bg-white">
          <h2>
            <img
              class="h2_img"
              src="/2-choices/img/logo_2-choices.svg"
              alt="2択でPonta"
              width="300"
              height="85"
            />
          </h2>
          <div class="box-overview">
            <p class="copy">ポイントが<br class="br_pc" />必ずもらえる！</p>
            <p class="explanation">
              どんな日もミカタに！Pontaの星座＆タロット占い！
            </p>
            <!--終了メッセージ-->
            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_6___}" />
<p class="event-end timer-target" data-end="2025-06-06T18:00:00+09:00">終了しました</p>

            <table class="overview">
              <tr>
                <th>設問数</th>
                <td>3問</td>
              </tr>
              <tr>
                <th>加算ポイント</th>
                <td>3Pontaポイント</td>
              </tr>
              <tr>
                <th>回答期間</th>
                <td>2025年3月31日(月)10:00〜6月6日(金)18:00</td>
              </tr>
              <tr>
                <th>加算対象</th>
                <td>期間中の回答（ログイン）</td>
              </tr>
              <tr>
                <th>加算時期</th>
                <td>2025年7月末頃予定</td>
              </tr>
            </table>
          </div>
          <p class="notes">
            下記の注意事項をご確認いただきご参加ください。<br />
            回答後に表示されるログインページよりログインいただくことでエントリーが完了します。
          </p>
          <!--attention-->
          <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_7___}" />
<section class="attention">
  <p class="attention-title">注意事項</p>
  <div class="attention-scrollable">
    <div class="attention-text">
      <p>※以下のポイントはPontaポイントを指します。</p>
      <p>
        ※以下の⽇程はすべて⼟⽇祝および当社が規定する休業⽇を除く営業⽇とします。
      </p>
      <br />
      <p>
        同⼀のアンケートまたはクイズに対し、回答期間中は何度でもご回答いただけますが、ポイント加算の対象条件は本ページ上部の案内をご確認ください。（ポイント加算がない設問も含む）
      </p>
      <br />
      <p>
        申込上限数の定めがある募集については、上限に達し次第、早期に受付を終了します。
        エントリー後のキャンセル、回答の変更等は受付できません。
      </p>
      <br />
      <p>
        「PontaWebでログイン」または、「au
        IDでログイン」のどちらかでお申し込みいただけます。ログインには、PontaWeb会員登録または、au
        ID連携が必要です。
      </p>
      <br />
      <p>
        ご回答からポイント加算までの間に以下の条件に当てはまった場合、エントリーは無効となり、ポイント加算対象外となりますので、予めご了承ください。<br />
        (1)回答後に出てくるログインページにてログインいただけなかった場合<br />
        (2)Pontaを退会された場合<br />
        (3)Ponta会員IDの登録内容に虚偽・不備がある場合<br />
        [PontaWebでお預入申し込みをされた場合]<br />
        (4)リクルートIDを退会された場合<br />
        (5)PontaWeb会員登録(Ponta会員IDの登録)が⾏われていない場合<br />
        [au IDでお預入申し込みをされた場合]<br />
        (6)au IDの連携を解除された場合<br />
        (7)au IDの連携が⾏われていない場合<br />
      </p>
      <br />
      <p>
        その他、(株)ロイヤリティ
        マーケティング、(株)リクルート、KDDI(株)が不正とみなしたPonta会員は、対象外とさせていただく場合があります。
      </p>
      <p>
        また、以下に該当する行為が確認された場合は、事前の告知なく本サービスの全部または一部を中断・停止または中止する場合があります。
      </p>
      <ul>
        <li>不正に取得したＩＤ ・パスワードを使用しアクセスする行為。</li>
        <li>システムの不具合を故意に悪用する行為 。</li>
        <li>通信データを改ざんする行為。</li>
        <li>
          第三者によるシステムの破壊や妨害行為。(データやソースコードの改ざん・破壊など)
        </li>
        <li>他の会員または第三者に不利益を与える行為。</li>
        <li>当社及び提携会社または第三者に不利益を与える行為。</li>
        <li>その他、当社が不適当と判断する行為。</li>
      </ul>
      <br />
      <p>
        本サービスの全部または一部が中断・停止または中止となったとしても、これに起因するPonta会員または他の第三者が被ったいかなる不利益、損害について、一切責任を負いかねます。
      </p>
      <br />
      <p>
        システム障害やシステムメンテナンス、その他の理由で一時的にお申し込みできない場合や、ポイントの加算が遅れる場合があります。
      </p>
      <p>
        通信回線の状態による遅延、不具合などにより本サービスへのアクセスやエントリー・表⽰などができないことにより発⽣した損害、またはそれに起因して発⽣したすべての事象につきましては、
        原因の如何によらず⼀切の責任を負いかねますので、ご了承の上ご利⽤願います。
      </p>
      <br />
      <p>
        その他、本サービスの内容は、事前の告知なく変更、または終了させていただく場合があります。
      </p>
      <br />
      <p>
        インターネット通信料、接続料はお客様のご負担となります。<br />
        ご利⽤の端末や環境等により、ページが正しく表⽰されない場合があります。<br />推奨環境は<a
          href="/sitepolicy.htm#recommend-env"
          target="_blank"
          rel="noopener"
          >こちら</a
        >
      </p>
      <br />
      <p>
        回答データは、Ponta会員規約に則り、個人を特定しない状態で分析・活用いたします。
        本サービスにご参加頂いたPonta会員のご登録メールアドレスに、アンケートまたはPontaサービスに関するおトクなお知らせをお送りさせて頂く場合があります。
      </p>
    </div>
  </div>
</section>

          <!--start-button-->
          <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_8___}" />
<label class="checkbox">
  <input type="checkbox" id="agree" />確認しました
</label>
<br />
<div class="button_container">
  <a
    id="apply"
    data-id="2-choices_0007-fortune_start"
    class="button_entry gray timer-target"
    data-start="2025-03-31T10:00:00+09:00"
    data-end="2025-06-06T18:00:00+09:00"
    href="./main?prv="
  >
    <div class="button_text">アンケートに答えて申し込む</div>
  </a>
  <img
    id="corner-image"
    class="corner-image left-top hidden"
    src="/2-choices/button_shine.svg"
  />
  <img
    id="corner-image"
    class="corner-image right-top hidden"
    src="/2-choices/button_shine.svg"
  />
</div>

          <!-- footer-ponta -->
          <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_9___}" />
<div class="footer-ponta">©Ponta</div>

        </div>
      </main>
    </div>
  </body>
</html>
`;
// Exports
export default code;